import React, { Component } from 'react';
import { SoundOutlined } from '@ant-design/icons';

/**
 * Plays back the Smart EMR recording using the audio_url from the API response.
 * Fixes the "Infinity duration" problem with MediaRecorder webm blobs so the
 * seek bar tracks correctly, and shows the total duration in the bar.
 *
 * Props:
 *  - audioUrl (required) direct URL from the API (smartEMRData item.audio_url)
 */
class SmartEmrAudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = { duration: 0 };
    this.audioRef = React.createRef();
    this._durationFixed = false;
  }

  formatTime = (seconds) => {
    if (!seconds || !isFinite(seconds)) return '00:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  // MediaRecorder webm files often report duration = Infinity. Force the browser
  // to calculate the real duration by seeking to the end once metadata loads.
  handleLoadedMetadata = () => {
    const audio = this.audioRef.current;
    if (!audio) return;
    if (audio.duration === Infinity || isNaN(audio.duration)) {
      const onSeeked = () => {
        audio.currentTime = 0;
        this._durationFixed = true;
        this.setState({ duration: audio.duration });
        audio.removeEventListener('seeked', onSeeked);
      };
      audio.addEventListener('seeked', onSeeked);
      // Trigger duration recalculation
      audio.currentTime = 1e101;
    } else {
      this.setState({ duration: audio.duration });
    }
  };

  handleDurationChange = () => {
    const audio = this.audioRef.current;
    if (audio && isFinite(audio.duration)) {
      this.setState({ duration: audio.duration });
    }
  };

  render() {
    const { audioUrl } = this.props;
    if (!audioUrl) return null;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '6px 0' }}>
        <SoundOutlined style={{ color: '#d24350' }} />
        {/* <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>Recording</span> */}
        <audio
          ref={this.audioRef}
          controls
          src={audioUrl}
          preload="metadata"
          onLoadedMetadata={this.handleLoadedMetadata}
          onDurationChange={this.handleDurationChange}
          style={{ height: 32, verticalAlign: 'middle' }}
        />
        {/* {this.state.duration > 0 && (
          <span style={{ fontSize: 12, color: '#666', fontWeight: 600, minWidth: 44 }}>
            {this.formatTime(this.state.duration)}
          </span>
        )} */}
      </div>
    );
  }
}

export default SmartEmrAudioPlayer;
